import React, { useState, useEffect } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import "../../Assets/Styles/Products.css"; 
import "../../Assets/Styles/Blog.css"; 
import { useParams } from "react-router-dom";

function EditPost() {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState({
        name: "",
        description: "",
        order: "",
        isActive: true
    });
    
    const { id } = useParams();

    const onInputChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.value });
    };

    const onCheckboxChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.checked });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await Instance.get(`${config.api_url}/faq/categories/${id}`);
                setCategory(result.data.data);
                setLoading(false);
            } catch (error) {
                setError(error);
                console.log(error);
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await Instance.patch(`${config.api_url}/faq/categories/${id}`, {
                name: category.name,
                description: category.description,
                order: category.order ? parseInt(category.order) : undefined,
                isActive: category.isActive
            });
            window.location = "/dashboard/blog";
        } catch (error) {
            console.error("-+-+-+-Erreur lors de la modification:", error);
            setError(error);
        }
    };

    if (loading) {
        return (
            <div className='a-new-post'>
                <SideBar />
                <div className="parent-new-product">
                    <p>Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='a-new-post'>
            <SideBar />
            <div className="parent-new-product">
                <form onSubmit={(e) => handleSubmit(e)} className="new-product custom-layout-product">
                    <div className="form-display ">
                        <div>
                            <label htmlFor="name">Nom de la catégorie</label>
                            <input
                                className="input"
                                value={category.name}
                                name="name"
                                type="text"
                                onChange={(e) => onInputChange(e)}
                                required={true}
                            />
                        </div>

                        <div id="description">
                            <label htmlFor="description">Description</label>
                            <textarea
                                className="input"
                                value={category.description}
                                name="description"
                                onChange={(e) => onInputChange(e)}
                            />
                        </div>

                        <div>
                            <label htmlFor="order">Ordre</label>
                            <input
                                className="input"
                                value={category.order}
                                name="order"
                                type="number"
                                onChange={(e) => onInputChange(e)}
                            />
                        </div>

                        <div>
                            <label htmlFor="isActive">
                                <input
                                    type="checkbox"
                                    name="isActive"
                                    checked={category.isActive}
                                    onChange={(e) => onCheckboxChange(e)}
                                />
                                {" "}Catégorie active
                            </label>
                        </div>
                    </div>

                    <div className="validate">
                        <button type="submit" className="add-new-element">
                            Modifier
                        </button>
                    </div>
                </form>
            </div>
            {error && (
                <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                    {error.response?.data?.message || "Une erreur est survenue"}
                </h1>
            )}
        </div>
    );
}

export default EditPost;